import { render, staticRenderFns } from "./SaveDialog.vue?vue&type=template&id=b55ffbf4&scoped=true"
import script from "./SaveDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55ffbf4",
  null
  
)

export default component.exports